import useRebrandedOfferTableStyles from './useRebrandedOfferTableStyles';

const RebrandedOffersTableStyles = () => {
  (useRebrandedOfferTableStyles as any)();

  return null;
};

export default RebrandedOffersTableStyles;
